import { CollapsibleSection } from "./CollapsibleSection";

interface PrayerSectionProps {
  title: string;
  confessions: string[];
  prayerPoints: string[];
  id?: string;
}

export const PrayerSection = ({ 
  title, 
  confessions = [], 
  prayerPoints = [],
  id
}: PrayerSectionProps) => {
  const timeOfDay = title.includes("Morning") ? "Morning" : "Evening";

  return (
    <CollapsibleSection title={title} id={id}>
      <div className="space-y-6">
        {/* Confessions Section */}
        <div className="bg-sage-50 rounded-lg p-6">
          <h3 className="text-xl font-serif font-semibold text-sage-800 mb-4">
            {timeOfDay} Confessions
          </h3>
          {confessions && confessions.length > 0 ? (
            <div className="space-y-3">
              {confessions.map((confession, index) => (
                <p key={index} className="text-lg italic text-sage-600 leading-relaxed text-center text-justify font-serif">
                  {confession}
                </p>
              ))}
            </div>
          ) : (
            <p className="text-sage-500 italic text-center text-justify font-serif">No confessions available for today.</p>
          )}
        </div>

        {/* Prayer Points Section */}
        <div className="bg-sage-50 rounded-lg p-6">
          <h3 className="text-xl font-serif font-semibold text-sage-800 mb-4">
            Prayer Points
          </h3>
          {prayerPoints && prayerPoints.length > 0 ? (
            <ol className="list-decimal list-inside space-y-3">
              {prayerPoints.map((point, index) => (
                <li key={index} className="text-lg text-sage-800 leading-relaxed text-center text-justify font-serif">
                  <span className="ml-2">{point}</span>
                </li>
              ))}
            </ol>
          ) : (
            <p className="text-sage-500 italic text-center text-justify font-serif">No prayer points available for today.</p>
          )}
        </div>
      </div>
    </CollapsibleSection>
  );
};